import { render, staticRenderFns } from "./TagBasic.vue?vue&type=template&id=70167ec7&scoped=true&"
import script from "./TagBasic.vue?vue&type=script&lang=js&"
export * from "./TagBasic.vue?vue&type=script&lang=js&"
import style0 from "./TagBasic.vue?vue&type=style&index=0&id=70167ec7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70167ec7",
  null
  
)

export default component.exports